<template>
<div>
  <h4 class="title-bar">일간 그래프</h4>
  <w-period-line-chart class="mr-b25" :rscInfoList="rscInfoList" :dateParams="dayDateParams" />

  <h4 class="title-bar">주간 그래프</h4>
  <w-period-line-chart class="mr-b25" :rscInfoList="rscInfoList" :dateParams="weekDateParams" />

  <h4 class="title-bar">월간 그래프</h4>
  <w-period-line-chart class="mr-b25" :rscInfoList="rscInfoList" :dateParams="monthDateParams" />

  <h4 class="title-bar">연간 그래프</h4>
  <w-period-line-chart :rscInfoList="rscInfoList" :dateParams="yearDateParams" />
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getIntervalDatetimeParams } from '@/utils/date';
import WPeriodLineChart from './components/PeriodLineChart';

export default {
  name: 'WPeriodRelativeView',
  components: {
    WPeriodLineChart,
  },
  props: {
    rscInfoList: {
      type: Array,
    },
  },
  data() {
    return {
      dayDateParams: {},
      weekDateParams: {},
      monthDateParams: {},
      yearDateParams: {},
    };
  },
  computed: {
    ...mapGetters(['analysisDateParams']),
  },
  watch: {
    rscInfoList: {
      immediate: true,
      handler() {
        const startDatetime = this.analysisDateParams.startDatetime;
        const endDatetime = this.analysisDateParams.endDatetime;
        this.dayDateParams = {
          startDatetime,
          endDatetime,
        };
        this.weekDateParams = {
          startDatetime: getIntervalDatetimeParams(startDatetime, 'day', 7),
          endDatetime,
        };
        this.monthDateParams = {
          startDatetime: getIntervalDatetimeParams(startDatetime, 'month', 1),
          endDatetime,
        };
        this.yearDateParams = {
          startDatetime: getIntervalDatetimeParams(startDatetime, 'year', 1),
          endDatetime,
        };
      },
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/popup/ResourceComparePeriodPopup/PeriodRelativeView.vue